import {
	GET_REFUNDS_REQUEST,
	GET_REFUNDS_SUCCESS,
	GET_REFUNDS_FAILURE,
} from "shared-frontend/redux/actions/refunds";

/**
 * Initial state
 */
const rootState = {
	refunds: {
		retrievingOrders: false,
		error: null,
	},
};

/**
 * Reducers
 */

/**
 * A reducer for the refunds object within the ui object.
 *
 * @param {Object} state The current state of the object.
 * @param {Object} action The current action received.
 * @returns {Object} The updated refunds object.
 */
export function uiRefundsReducer( state = rootState.refunds, action ) {
	switch ( action.type ) {
		case GET_REFUNDS_REQUEST:
			return Object.assign( {}, state, {
				retrievingRefunds: true,
				error: null,
			} );
		case GET_REFUNDS_SUCCESS:
			return Object.assign( {}, state, {
				retrievingRefunds: false,
			} );
		case GET_REFUNDS_FAILURE:
			return Object.assign( {}, state, {
				retrievingRefunds: false,
				error: action.error,
			} );
		default:
			return state;
	}
}
